import DDLCStatus from './CSAllStatus';
import { IInitialState } from 'src/store/initialState';
import { connect } from 'react-redux';
import {
  datesFilterSel,
  statusFilterSel,
  sortFilterSel,
  invoicesActions,
  orderFilterSel
} from 'src/store/modules/invoices';
import {
  IFiltersInvoice,
  IPaginationInvoice
} from 'src/services/invoice/InvoiceService';
import {
  isPendingSel,
  showStatusModalSel
} from 'src/store/modules/paysimplepayment';
import { creditCardActions } from 'src/store/modules/creditcard';
import actions from 'src/store/modules/invoices/actions';

const mapStateToProps = (state: IInitialState) => ({
  datesFilter: datesFilterSel(state),
  statusFilter: statusFilterSel(state),
  sortFilter: sortFilterSel(state),
  isPendingPayment: isPendingSel(state),
  showStatusModal: showStatusModalSel(state),
  orderStatusFilter: orderFilterSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  getInvoices: (filters: IFiltersInvoice, pagination: IPaginationInvoice) =>
    dispatch(actions.getInvoices(filters, pagination))
});

export const pureComponent = DDLCStatus;
export default connect(mapStateToProps, mapDispatchToProps)(DDLCStatus);

// export default MultipleSelectStatus;
